/**
 * Billing / checkout contracts (Monetization v2, sc-6943) shared between
 * the cabinets and apps/api. PayPal is Merchant of Record — no card data
 * touches us. A player buys one of three passes; the server starts the
 * PayPal purchase and returns the approve URL the cabinet redirects to.
 */
/**
 * The three passes the paywall offers, in display order. Prices MUST match
 * the PayPal side (day-pass order amount + the P-xxxx plan prices) — the
 * server is authoritative, this is the storefront copy the cabinet renders.
 * Keep in step with docs + PAYPAL_DAY_PASS_PRICE / the billing-plan minting
 * tool (tools/paypal-create-sandbox-plans.mjs).
 */
export const PASS_CATALOG = [
    {
        kind: 'day_pass',
        label: 'Day Pass',
        priceUsd: '0.99',
        cadence: '24 hours',
        blurb: 'Unlimited play for a day. One-time — nothing recurring.',
    },
    {
        kind: 'week_sub',
        label: 'Week Pass',
        priceUsd: '2.99',
        cadence: 'billed weekly',
        blurb: 'Unlimited play, renews every week. Cancel anytime.',
        featured: true,
    },
    {
        kind: 'month_sub',
        label: 'Month Pass',
        priceUsd: '8.99',
        cadence: 'billed monthly',
        blurb: 'Best value — unlimited play all month. Cancel anytime.',
    },
];
//# sourceMappingURL=billing.js.map